import { NewPageBlurb } from "./new_page_blurb";

export function EventTemplateBlurb(props: { onClick: () => void }) {
	return (
		<NewPageBlurb
			onClick={props.onClick}
			title="Event Templates"
			description="View and modify event templates for this server"
			is_new={true}
		/>
	);
}
